import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, Box, Typography, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import { useTranslate } from 'react-admin';
import emailSend from '../../assets/mailsend.png';

const useStyles = makeStyles(theme => ({
    dialogCloseBtn: {
        backgroundColor: theme.palette.common.white,
        marginLeft: 10
    },
}));

function DialogSendSuccess({ open, onClose, message }) {
    const classes = useStyles();
    const translate = useTranslate();

    return (
        <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title" >
            <Box width={400} textAlign='center'>
                <Box display='flex' justifyContent='flex-end' alignItems='center' mr={2} mt={1}>
                    <Typography variant='subtitle2'>{translate(`pos.user.close`)}</Typography>
                    <IconButton size='small' className={classes.dialogCloseBtn} onClick={onClose}>
                        <Close color='primary' />
                    </IconButton>
                </Box>
                <Box display='flex' justifyContent='center' width='100%' mt={2}>
                    <img src={emailSend} width="230" height="230" />
                </Box>
                <Box display='flex' justifyContent='center' width='100%' mt={2}>
                <Typography variant='h4' style={{ fontWeight: 'normal', marginBottom: '50px',width:"250px",color:'rgba(0, 0, 0, 0.87)' }}>{message}</Typography>
                </Box>
            </Box>
        </Dialog>
    );
}

DialogSendSuccess.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    message: PropTypes.string.isRequired,
};

export default DialogSendSuccess;
